import React from 'react'
import parse from 'html-react-parser'
import { usePublication } from '../../../hooks/usePublication'
import { ButtonsRight } from '../../../interfaces/UI'
import { useNavigate, useParams } from 'react-router-dom';
import { ModalTrivia } from './Trivia';
import { useTrivia } from '../../../hooks';
import { findTypeOption, typeLibro } from '../../../interfaces/Publication';

interface ChapterIndexProps {
  openButtons: ButtonsRight;
  setOpenButtons: (buttosn: ButtonsRight) => void;
}

const ChapterIndex = ({ openButtons, setOpenButtons }: ChapterIndexProps) => {

  let { idRevista, idLibro } = useParams();
  const typeLibro: typeLibro = idLibro ? "libro" : "revista"
  const route = findTypeOption(typeLibro)?.route || ""


  const { openModalTrivia, setCurrentTriviaId } = useTrivia();
  const { sections, publication, currentSection } = usePublication()

  const history = useNavigate();

  const handleRedirect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRoute = event.target.value;
    history(selectedRoute);
  };

  const openTrivia = () => {
    const overlay = document.querySelector('.js-backdrop');
    overlay?.classList.add("visible-fadein");
    setCurrentTriviaId(currentSection.trivia || 0);
    openModalTrivia();
  }

  return (
    <div id="option-1" className={`aside__content ${openButtons.optIndex ? "active" : ""}`}>

      <div className="aside__content-header">
        <h3>{typeLibro === 'libro' ? 'Contenido del capítulo' : 'Contenido de la Sección'}</h3>
        <button
          className="btn btn-rounded btn-rounded-transparent btn-close"
          aria-label={`Cerrar Indice del ${typeLibro === 'libro' ? 'capítulo' : 'Artículos'}`}
          onClick={() => {
            let tmpBtns: ButtonsRight = { ...openButtons }
            tmpBtns.optIndex = false
            setOpenButtons(tmpBtns)
          }}
        >
          <span className="btn__icon"
          ><i className="icon icon-vpro-close"></i
          ></span>
        </button>
      </div>

      <div className="aside__content-data main-sb">
        <div className="chap-index">
          <div className="chap-index__header">
            <div className="select-dd sticky">
              <select
                name="capitulos"
                id="capitulos-select"
                className="select-dd__select"
                onChange={handleRedirect}
                value={`/${route}/${publication.id}/${publication.currentSection}`}
              >
                {
                  sections.map((section, index) =>
                    <option key={index} value={typeLibro === 'libro' ? `/libros/${publication.id}/${index}` : `/revista/${publication.id}/${index}`}>{parse(section.title)}</option>
                  )
                }
              </select>
              <span className="select-dd__arrow"></span>
            </div>
            {/* <!-- <span className="chap-index__chap-num">Capítulo 50</span> --> */}
          </div>

          <ul className="chap-index__index unstyled-list">
            {
              currentSection ? (
                currentSection.subsections?.map((subSection, index) =>
                  <li className="chap-index__item" key={index}>
                    <a className="chap-index__link" href={`#C${subSection.id}`} data-scrollspy
                    >{subSection.title}</a
                    >
                    <span className={`chap-index__track ${index === 0 ? "chap-index__track--start" : ""}`}></span>
                  </li>
                )
              ) : null
            }
          </ul>
        </div>
      </div>

      {
        currentSection?.trivia && (
          <div className="aside__content-actions">
            <button
              type="button"
              className="btn btn--fw btn-alt-primary btn-alt-primary--red js-btn-modal"
              data-modal-trigger="trivia"
              aria-label="Cerrar ventana de Trivia"
              onClick={openTrivia}
            >
              <span className="btn__label">Trivia</span>
            </button>
          </div>
        )
      }

    </div>

  )
}

export default ChapterIndex
